<template>
  <v-card class="network-status pa-3" variant="outlined" color="primary-lighten-5" border>
    <div class="d-flex flex-wrap align-center">
      <div class="d-flex align-center">
        <div class="pulse-indicator me-3">
          <div class="pulse"></div>
        </div>
        <div>
          <div class="text-subtitle-2 font-weight-medium">Status da Rede QuarnX</div>
          <div class="d-flex align-center">
            <v-chip
              size="small"
              color="success"
              variant="text"
              class="font-weight-medium"
            >
              <v-icon size="small" start>mdi-check-circle</v-icon>
              Rede Operacional
            </v-chip>
            <span class="text-caption ms-2">{{ tempoSincronizacao }}</span>
          </div>
        </div>
      </div>
      
      <v-divider vertical class="mx-4 d-none d-sm-flex" />
      
      <div class="d-flex flex-wrap flex-grow-1 justify-space-between">
        <div class="metric-item">
          <div class="text-overline">{{ t('blocks.height') }}</div>
          <div class="d-flex align-center">
            <span class="text-body-1 font-weight-medium">{{ formatarNumero(stats.blockHeight) }}</span>
            <v-tooltip location="top">
              <template v-slot:activator="{ props }">
                <v-icon
                  v-bind="props"
                  size="small"
                  color="success"
                  class="ms-1"
                >
                  mdi-trending-up
                </v-icon>
              </template>
              Último bloco produzido há {{ tempoUltimoBloco }}
            </v-tooltip>
          </div>
        </div>
        
        <div class="metric-item">
          <div class="text-overline">TPS</div>
          <div class="d-flex align-center">
            <span class="text-body-1 font-weight-medium">{{ stats.tps.toFixed(1) }}</span>
            <v-tooltip location="top">
              <template v-slot:activator="{ props }">
                <v-icon
                  v-bind="props"
                  size="small"
                  :color="stats.tps > 10 ? 'warning' : 'success'"
                  class="ms-1"
                >
                  {{ stats.tps > 10 ? 'mdi-trending-up' : 'mdi-trending-down' }}
                </v-icon>
              </template>
              Transações por segundo (média 5 min)
            </v-tooltip>
          </div>
        </div>
        
        <div class="metric-item">
          <div class="text-overline">Gas</div>
          <div class="text-body-1 font-weight-medium">{{ stats.gasPrice }} q{{ coin }}</div>
        </div>
        
        <div class="metric-item">
          <div class="text-overline">Validadores</div>
          <div class="d-flex align-center">
            <span class="text-body-1 font-weight-medium">{{ stats.activeValidators }}/{{ stats.totalValidators }}</span>
            <v-tooltip location="top">
              <template v-slot:activator="{ props }">
                <v-icon
                  v-bind="props"
                  size="small"
                  :color="stats.activeValidators === stats.totalValidators ? 'success' : 'warning'"
                  class="ms-1"
                >
                  mdi-shield-check
                </v-icon>
              </template>
              {{ stats.activeValidators }} validadores ativos de {{ stats.totalValidators }} totais
            </v-tooltip>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { useAppStore } from '@/stores/app'
import { useBlockchainStore } from '@/stores/blockchain'
import { formatarNumero } from '@/services/utilidades'

export default {
  name: 'NetworkStatus',
  data() {
    return {
      intervaloAtualizacao: null,
      ultimaAtualizacao: new Date()
    }
  },
  computed: {
    appStore() {
      return useAppStore()
    },
    blockchainStore() {
      return useBlockchainStore()
    },
    stats() {
      return {
        blockHeight: this.appStore.networkStatus.blockHeight || 0,
        activeValidators: this.appStore.networkStatus.activeValidators || 0,
        totalValidators: this.appStore.networkStatus.totalValidators || 0,
        tps: this.appStore.networkStatus.tps || 0,
        gasPrice: this.appStore.networkStatus.gasPrice || 5
      }
    },
    tempoSincronizacao() {
      const diffMs = new Date() - this.ultimaAtualizacao
      const diffSec = Math.floor(diffMs / 1000)
      
      if (diffSec < 60) {
        return `Atualizado ${diffSec}s atrás`
      } else {
        const diffMin = Math.floor(diffSec / 60)
        return `Atualizado ${diffMin}min atrás`
      }
    },
    tempoUltimoBloco() {
      // Simula um tempo aleatório para o último bloco (entre 5 e 20 segundos)
      const segundos = 3 // Tempo real de bloco QuarnX
      return `${segundos} segundos`
    }
  },
  methods: {
    formatarNumero,
    
    atualizarStatus() {
      this.blockchainStore.updateBlockchainStats()
      this.ultimaAtualizacao = new Date()
    }
  },
  mounted() {
    this.atualizarStatus()
    
    // Atualiza o status da rede a cada 10 segundos
    this.intervaloAtualizacao = setInterval(() => {
      this.atualizarStatus()
    }, 10000)
  },
  beforeUnmount() {
    if (this.intervaloAtualizacao) {
      clearInterval(this.intervaloAtualizacao)
    }
  }
}
</script>

<style scoped>
.network-status {
  border-radius: 8px;
}

.metric-item {
  margin: 0 16px 0 0;
}

.pulse-indicator {
  width: 14px;
  height: 14px;
  position: relative;
}

.pulse {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #4caf50;
  position: absolute;
  top: 2px;
  left: 2px;
}

.pulse::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: rgba(76, 175, 80, 0.3);
  animation: pulse 2s infinite;
  top: 0;
  left: 0;
  transform: scale(1);
  transform-origin: center;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.7;
  }
  70% {
    transform: scale(2.5);
    opacity: 0;
  }
  100% {
    transform: scale(2.5);
    opacity: 0;
  }
}

@media (max-width: 600px) {
  .metric-item {
    margin: 8px 16px 8px 0;
    min-width: 100px;
  }
}
</style>
